jQuery(function(){

    var travellerCount = 1;
    var labelCount = 1;
    var label;

    jQuery('.quick-quote-request-form__add-traveller-link').on('click', function(event) {
        event.preventDefault();

        var $parent = jQuery(this).parent('.quick-quote-request-form__add-traveller-link-container');

        travellerCount++;
        labelCount++;
        label = 'Traveller <span class="quick-quote__traveller-label">' + travellerCount + '</span>\'s Date of Birth';

        var html = '<div class="input__calendar quick-quote__calendar-input" ><div class="input__calendar-container" > <label for="birthdate-' + labelCount + '" class="label">' + label + '</label><div class="quick-quote__dismiss-container input__text-container"><button class="quick-quote__calendar-dismiss" title="Remove Traveller">&times;</button><input type="text" name="birthdate-' + labelCount + '" id="birthdate-' + labelCount + '" name="birthdate-' + labelCount + '" class="text-field text-field--calendar" data-parsley-required="true" data-parsley-errors-messages-disabled><svg xmlns=http://www.w3.org/2000/svg width=24 height=24 viewBox="0 0 24 24"><g fill=none stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"><polyline points="4.5,2.5 0.5,2.5 0.5,23.5 23.5,23.5 23.5,2.5 19.5,2.5"/><rect x="4.5" y=".5" width="3" height="4" /><rect x="16.5" y=".5" width="3" height="4" /><line x1="7.5" y1="2.5" x2="16.5" y2="2.5" /><line x1=".5" y1="7.5" x2="23.5" y2="7.5" /><polyline points="9.5,19.5 9.5,11.5 7.5,13.5"/><line x1="7.5" y1="19.5" x2="11.5" y2="19.5" /><g><polyline points="14,19.5 17,11.5 12,11.5 12,12.5"/><line x1="13.5" y1="15.5" x2="16.5" y2="15.5" /></g></g></svg> <span class="input__calendar-placeholder">(MM/DD/YYYY)</span><div class="input__text-error-message"><svg xmlns=http://www.w3.org/2000/svg width="24" height="24" viewBox="0 0 24 24"><path d="M11.499 1C5.148 1 0 6.148 0 12.499s5.148 11.499 11.499 11.499 11.499-5.148 11.499-11.499S17.85 1 11.499 1zm-.5 6a.5.5 0 1 1 1 0v7a.5.5 0 1 1-1 0V7zm.519 11.5H11.5a.999.999 0 0 1-.018-1.999l.018-.001a1 1 0 0 1 .018 2z"/></svg> <span class="input__text-error-message-copy">This field is required</span></div></div> </div>';

        $parent.before(html);

        // the new calendar input
        var $calendar = $parent.prev().find('.text-field--calendar');

        $calendar.pikaday({
            format: "MM/DD/YYYY"
        });

        $calendar.mask('00/00/0000');

        // don't need to delegate this here, since we know for sure it exists
        jQuery('.quick-quote__calendar-dismiss').on('click', function (event) {
            event.preventDefault();

            $calendar.pikaday('destroy');
            jQuery(this).parents('.quick-quote__calendar-input').remove();

            var $inputs = jQuery('.quick-quote__calendar-input');

            jQuery.each($inputs, function (index, item) {
                var number = index + 2;
                var $updateCalendar = jQuery(this).find('.text-field--calendar');

                jQuery(this).find('.quick-quote__traveller-label').text(number);

                $updateCalendar.pikaday({
                    format: "MM/DD/YYYY"
                });

            });

            travellerCount = $inputs.length + 1;
        });

    });



});